import { Breadcrumbs } from 'AbstractElements';
import MaterialContain from 'Component/Learning/Materi';

const MaterialList = () => {
    return (
        <>
            <Breadcrumbs grandparent="Learning" parent="Materi" title="Daftar Materi" />
            <MaterialContain />
        </>
    );
};
export default MaterialList;